import React from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';

// 환경 한정 기능 라우트 가드. 메뉴(main_menu.js)와 같은 /api/config/features 값을
// ProtectedLayout이 공유하는 features 상태로 읽는다(별도 조회 없음).
const FeatureGuard = ({ feature, children }) => {
    const { features } = useOutletContext();

    // 조회 중이거나 조회에 실패하면(null) 화면을 그리지 않는다 — fail-closed
    if (!features) return null;

    // 조회 결과 기능이 꺼진 환경(PRD의 iot 등)에서 URL로 직접 들어오면 대시보드로 보낸다
    if (features[feature] !== true) return <Navigate to="/dashboard" replace />;

    return children;
};

export default FeatureGuard;
